export const REGULAR = 'regular';
export const VISITOR_CALLING = 'visitor-calling';
export const VISITOR_MISSED = 'visitor-missed';

export default [REGULAR, VISITOR_CALLING, VISITOR_MISSED];
